var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[_vm.wrapClass, { mono: _vm.username === null }]},[(_vm.username)?[_vm._v("@"+_vm._s(_vm.username))]:[_vm._v(_vm._s(_vm.truncate(_vm.userAddress, 8)))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }